import React, { forwardRef } from "react";
import { Row, Col, Container, Button } from "react-bootstrap";
import { showWarning, showInfo, showSuccess } from "../utility/ui/notifications/Toaster";
import { ExportToExcel } from "../utility/data/export/PRODWI_Excel";
import { PRODexportreport } from "../../Services/WI-services";
import { useWelderReportCommon } from "../../hooks/useWelderReportCommon";
import WelderReportFilters from "../utility/forms/WelderReportFilters";
import { validateWelderReportForm } from "../../utils/welderReportValidation";

const ProdReport = forwardRef((props, ref) => {
  const {
    wiobj, setwiobj, error, setError, Slipstatus,
    getUniqueProjectNumbers, getJointNosForSelectedProject, getWelderForSelectedProject,
    handleProjectChange, handleJointChange, handleWelderChange, handleSlipStatusChange
  } = useWelderReportCommon();

  let Data = [];
  let reporName = "ProdReport";

  const handleSubmit = async () => {
    if (!validateWelderReportForm(wiobj, ['fromDate', 'toDate', 'slipStatus'])) {
      return;
    }

    try {
      const result = await PRODexportreport(wiobj);


      let filename = "productivity measurement";
      let sheetName = "Report_WeldingProductivity";
      let excelHeader = "LIST OF Product Report";
      let displayNote = "";

      if (result?.length > 0) {
        result?.forEach((row) => {
          Data.push({
            A: "",
            B: row.WI_Project_No,
            C: row.WI_SlipDate,
            D: row.WI_plant,
            E: row.WI_Slip,
            F: row.WI_Slip_Status === "Cancelled" ? "Yes" : "No",
            G: row.WI_Joint_No,
            H: row.WI_WPS_No,
            I: row.WI_Process,
            J: row.WI_Type,
            K: row.WI_Welder_Id,
            L: row.WI_Welder_Name,
            M: row.WI_CreatedBy,
            N: row.WI_ItemCode,
            O: row.WI_ItemDesc,
            P: row.WI_ItemGroup,
            Q: row.WI_WCinKgs,
            R: row.WI_WMinKgs,
            //S: row.WI_WMinKgs,
          });

        });

        let titleCell = "E3";
        let titleWelderRange = "G1:Y5";
        let tbodyHeadRange = "A6:R6";
        let tbodyRange = "A7";
        let blankRow = "A5:R5";
        let width = [
          { col: "A", width: 2.5 },
          { col: "B", width: 13.7 },
          { col: "C", width: 13.7 },
          { col: "D", width: 13.7 },
          { col: "E", width: 8.5 },
          { col: "F", width: 12.5 },
          { col: "G", width: 16.5 },
          { col: "H", width: 20 },
          { col: "I", width: 13.7 },
          { col: "J", width: 13.7 },
          { col: "K", width: 15 },
          { col: "L", width: 18 },
          { col: "M", width: 20 },
          { col: "N", width: 20 },
          { col: "O", width: 20 },
          { col: "P", width: 20 },
          { col: "Q", width: 20 },
          { col: "R", width: 20 },
          //{ col: "S", width: 20 },
        ];
        let Headings = [
          { col: "G2", value: excelHeader },
          {
            col: "C4",
            value: displayNote,
          },
        ];

        ExportToExcel(filename, Data, {
          colwidth: width,
          titleCell,
          titleWelderRange,
          tbodyHeadRange,
          tbodyRange,
          blankRow,
          Headings,
          sheetName,
          reportName: reporName
        });
      } else {
        showInfo("There are no records matching to filters.");
      }

      if (result.length > 0) {
        showSuccess("Exported successfully");
      }
    } catch (error) {
      console.error('Error in handleSubmit:', error);
      showWarning('An error occurred while processing the request. Please try again.');
    }
  };


  return (
    <>
      <Container fluid>
        <Row className="RowHeight mb-4 ml-2">
          <Col md={12} sm={12} xs={12} className="ListTitle">
            Productivity Measurement Report Filters
          </Col>
        </Row>
        <WelderReportFilters
          wiobj={wiobj}
          setwiobj={setwiobj}
          error={error}
          setError={setError}
          uniqueProjectNumbers={getUniqueProjectNumbers()}
          jointOptions={getJointNosForSelectedProject()}
          welderOptions={getWelderForSelectedProject()}
          slipStatusOptions={Slipstatus}
          onProjectChange={handleProjectChange}
          onJointChange={handleJointChange}
          onWelderChange={handleWelderChange}
          onSlipStatusChange={handleSlipStatusChange}
          showFileFormat={false}
        />
        <Row>
          <Col>
            <Button
              style={{ position: "relative", right: "20px", bottom: "10px" }}
              onClick={handleSubmit}
              className="btn-add-color semiBoldToggleButton rightAlignedButton"
            >
              Submit
            </Button>
          </Col>
        </Row>
      </Container>


    </>
  );
});

export default ProdReport;